<rma-google-map
  class="block"
  [options]="options"
  [enableDrawing]="false"
  [padding]="store.padding$ | async"
  [markers]="store.markers$ | async"
  [activeMarker]="store.activeMarker$ | async"
  [error]="store.error$ | async | transloco"
  [isSmallDevice]="store.isSmallDevice$ | async"
  [resetBounds]="store.resetBounds$ | async"
  [fullscreenRoute]="fullscreenRoute"
  [fullscreenMapType]="store.mapType$ | async"
  (boundsSet)="onBoundsChanged($event)"
  (markerSelected)="onMarkerSelected($event)"
  (markerDeselected)="store.setViewedMarker($event)"
  buttonTopLocation="top-2"
>
  <div class="absolute left-2 top-2 z-10">
    <rma-marker-type-toggle
      class="drop-shadow-lg"
      [mapTypes]="mapTypes"
      [mapType]="store.mapType$ | async"
      [verticalType]="store.verticalType$ | async"
      [skipRouting]="true"
      (mapTypeSelected)="onMapTypeSelected($event)"
      displayMode="select"
    />
  </div>
</rma-google-map>
